export { default } from "./date-details-field";
